module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.type
  }, [_vm._l((_vm.items), function(item) {
    return _c('router-link', {
      key: item.id,
      attrs: {
        "to": {
          name: _vm.link,
          params: {
            id: item.id
          }
        }
      }
    }, [(item.cover && _vm.displayImg) ? _c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (item.cover),
        expression: "item.cover"
      }],
      attrs: {
        "alt": 'Pochette n°' + item.id
      }
    }) : _vm._e(), _vm._v(" "), (item.picture && _vm.displayImg) ? _c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (item.picture),
        expression: "item.picture"
      }],
      attrs: {
        "alt": 'Image n°' + item.id
      }
    }) : _vm._e(), _vm._v(" "), _c('div', _vm._l((_vm.fields), function(field) {
      return _c('div', [_vm._v("\n        " + _vm._s(field === 'date' ? _vm.$d(new Date(item[field]), 'long') : item[field]) + "\n      ")])
    }))])
  }), _vm._v(" "), (_vm.scroll) ? _c('infinite-loading', {
    ref: "infiniteLoading",
    attrs: {
      "on-infinite": _vm.onInfinite,
      "distance": 30,
      "spinner": "waveDots"
    }
  }, [_c('span', {
    slot: "no-results"
  }, [_vm._v(_vm._s(_vm.$t('loader.none')))]), _vm._v(" "), _c('span', {
    slot: "no-more"
  }, [_vm._v(_vm._s(_vm.$t('loader.end')))])]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a462c84"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/List.vue
// module id = 251
// module chunks = 0